import React, { useEffect, useState } from "react";
import { Drawer, notification, Checkbox, Row, Col, Form, Collapse, Input, Button } from "antd";
import { RollbackOutlined, KeyOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import CustomScrollbars from "util/CustomScrollbars";

import ContactList from "components/contact/ContactList";
import RequestHandler from "../../util/RequestHandler";

const UserAccountRoles = (props) => {
  const history = useHistory();
  const [bankListForTRY, setBankListForTRY] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [drawerState, setDrawerState] = useState(false);
  const [isFullAccountChecked, setIsFullAccountChecked] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [checkboxDisabled, setCheckboxDisabled] = useState(false);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Hesap yetkilendirme işlemi başarılı!',
      duration: 2,
    });
  };

  const onContactSelect = (value) => {
    RequestHandler.post(`/User/AddFullAccountAuth`, { userId: props.match.params.userId }, false, { rawResponse: true }).then(res => {
      if (res.status == 200) {
        setIsFullAccountChecked(res.data.data.isFullAccountAuth)
        openNotificationWithIcon('success');
        setDisabled(res.data.data.isFullAccountAuth)
      }
    });
  };

  const setAllSelectChecked = () => {
    const tenantAccountUsers = contactList.map((t) => ({
      tenantAccountId: t.id,
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId
    }));
    RequestHandler.post(`/TenantAccount/AddRangeTenantAccountUser`, tenantAccountUsers, false, { rawResponse: true }).then(response => {
      if (response.status == 200) {
        openNotificationWithIcon('success');
        getComp(contactList[0].bankId)
      }
    });
  }

  const onToggleDrawer = () => setDrawerState(true);

  const onToggleDrawerClose = () => setDrawerState(false);

  const getComp = (val) => {
    setSelectedBankId(val);
    RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId,
      bankId: val
    }, false).then(response => {
      setContactList(response);
    });
  }

  useEffect(() => {
    RequestHandler.get(`/User/IsAdmin?userId=${props.match.params.userId}`).then(response => {
      setDisabled(response);
      setCheckboxDisabled(response);
    });

    RequestHandler.post(`/User/IsFullAccountAuth`, { userId: props.match.params.userId }, false).then(response => {
      setIsFullAccountChecked(response.data);
      setDisabled(response.data);
    });

    RequestHandler.get(`/TenantAccount?$apply=groupby((BankLogo,BankId,BankCode),aggregate(Balance with sum as Balance))`).then(response => {
      setBankListForTRY(response);
    });
  }, [setIsFullAccountChecked, setDisabled]);

  const goBankAccount = (value) => {
    setSelectedBankId(value)
    RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId,
      bankId: value
    }, false).then(response => {
      setContactList(response);
    });
  }
  const [form] = Form.useForm();
  const clearFilter = () => {
    form.resetFields();
    setContactList([]);
    setSelectedBankId(undefined)
  };
  const onFinish = (values) => {
    RequestHandler.post(`/TenantAccount/GetWithTenantAccountUser`, {
      tenantId: localStorage.getItem("tenantId"),
      userId: props.match.params.userId,
      iban: values.iban,
      accountNumber: values.accountNumber
    }, false).then(response => {
      if (response.length != 0) {
        setSelectedBankId(response[0].bankId)
        setContactList(response);
      } else {
        setContactList([]);
        setSelectedBankId(undefined)
      }
    });
  }

  const ContactSideBar = () => {
    return <div style={disabled ? { pointerEvents: "none", opacity: "0.4" } : {}} className="gx-module-side">
      <div className="gx-module-side-header">
        <div className="gx-module-logo">
          <span>Kullanıcı Hesap Yetkileri </span>
        </div>
      </div>

      <div className="gx-module-side-content">

        <CustomScrollbars className="gx-module-side-scroll">
          <div className="gx-module-add-task">

          </div>
          <div className="gx-module-side-nav">
            <ul className="gx-module-nav">
              {bankListForTRY.map(option =>
                <li key={option.bankId} className="gx-nav-item" onClick={() => goBankAccount(option.bankId)}
                  style={{
                    cursor: 'pointer',
                    backgroundColor: selectedBankId === option.bankId ? '#bccae2' : 'transparent',
                    padding: '10px',
                    margin: '5px 0',
                    borderRadius: '5px'
                  }}
                >
                  <span
                    className={`gx-link`} >
                    <img style={{ width: '80%' }} src={option.bankLogo}  ></img>
                  </span>
                </li>
              )}

            </ul>
          </div>
        </CustomScrollbars>
      </div>
    </div>

  };

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}><a onClick={() => history.goBack()} style={{ color: 'black', marginLeft: "4%" }}> <RollbackOutlined /> GERİ DÖN</a></Col>
        <Col flex={4}></Col>
      </Row>
      <Row>
        <Col flex={1}> <p style={{ fontSize: '200%', marginLeft: "4%" }}><KeyOutlined /> HESAP YETKİLENDİRME</p><hr></hr><br></br></Col>
        <Col flex={4}>
          <div className="gx-module-box-topbar">
            <Checkbox className="gx-icon-btn"
              checked={isFullAccountChecked}
              value="checkedF"
              disabled={checkboxDisabled}
              onClick={() => onContactSelect()} /> <p>Tüm Yetkiler</p>
          </div>
        </Col>
      </Row>
      <div className="gx-main-content">
        <div className="gx-app-module">
          <div className="gx-d-block gx-d-lg-none">
            <Drawer
              placement="left"
              width={100}
              closable={false}
              visible={drawerState}
              onClose={onToggleDrawerClose}>
              {ContactSideBar()}
            </Drawer>
          </div>
          <div className="gx-module-sidenav gx-d-none gx-d-lg-flex">
            {ContactSideBar()}
          </div>

          <div className="gx-module-box">
            <div className="gx-module-box-header">
              <span className="gx-drawer-btn gx-d-flex gx-d-lg-none">
                <i className="icon icon-menu gx-icon-btn" aria-label="Menu"
                  onClick={onToggleDrawer} />
              </span>

              <Row id="filterArea" >
                <Col span={24}>
                  <Collapse>
                    <Collapse.Panel header="Filtreleme için tıklayınız.">
                      <Form
                        name="filter"
                        form={form}
                        initialValues={{
                          remember: true,
                        }}
                        layout="vertical"
                        onFinish={onFinish}
                      >
                        <Row style={{ flexDirection: "row" }}>
                          <Col xs={24} md={12} lg={6}>
                            <Form.Item name="iban" label="IBAN :">
                              <Input allowClear />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={12} lg={6}>
                            <Form.Item name="accountNumber" label="Hesap No :">
                              <Input allowClear />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row style={{ flexDirection: "row" }}>
                          <Col span={24} style={{ textAlign: "right" }}>
                            <Button
                              danger
                              size="small"
                              icon={<CloseOutlined />}
                              onClick={() => clearFilter()}
                            >
                              Sıfırla
                            </Button>
                            <Button
                              type="primary"
                              size="small"
                              icon={<SearchOutlined />}
                              style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                              htmlType="submit"
                            >
                              Filtrele
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </Collapse.Panel>
                  </Collapse>
                </Col>
              </Row>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: "13px" }}>
                <Button
                  disabled={selectedBankId == undefined}
                  onClick={setAllSelectChecked} >Tümünü Seç</Button>
              </div>
            </div>
            <div className="gx-module-box-content">

              <CustomScrollbars className="gx-module-content-scroll">
                {contactList.length === 0 ?
                  <div className="gx-h-100 gx-d-flex gx-align-items-center gx-justify-content-center">
                    Lütfen bir banka seçiniz
                  </div>
                  : <ContactList disabledPage={isFullAccountChecked} getDataComp={getComp} userId={props.match.params.userId} contactList={contactList} />
                }
              </CustomScrollbars>

            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default UserAccountRoles;
